export const searchData = [
    {
        id: 1,
        title: 'Bootstrapdash',
        link: 'https://www.bootstrapdash.com/',
        meta: 'Read writing from Bootstrapdash Team on Medium. We design and develop awesome admin dashboard templates with Bootstrap, so you can kick-start and speed up your development. www.bootstrapdash.com.',
    },
    {
        id: 2,
        title: 'Bootstrapdash Team – Medium',
        link: 'https://medium.com/@bootstrapdash',
        meta: 'Read writing from Bootstrapdash Team on Medium. We design and develop awesome admin dashboard templates with Bootstrap, so you can kick-start and speed up your development. www.bootstrapdash.com.',
    },
    {
        id: 3,
        title: 'Bootstrapdash · GitHub',
        link: 'https://github.com/@bootstrapdash',
        meta: 'Bootstrapdash has 1 repository available. Follow their code on GitHub.',
    },
    {
        id: 4,
        title: 'bootstrapdash.com - Home | Facebook',
        link: 'https://facebook.com/bootstrapdash',
        meta: 'Bootstrapdash.com. 9 likes · 4 talking about this. Clean, customisable admin dashboard template themes / UI WebApp Kits with a huge collection of...',
    },
    {
        id: 5,
        title: 'Bootstrapdash Team – Hacker Noon',
        link: 'https://hackernoon.com/@bootstrapdash',
        meta: 'Oct 9, 2017 - Read writing from Bootstrapdash Team in Hacker Noon. We design and develop awesome admin dashboard templates with Bootstrap, so you can kick-start and speed up your development. www.bootstrapdash.com.',
    },
    {
        id: 6,
        title: 'Bootstrapdash | Crunchbase',
        link: 'https://www.crunchbase.com/organization/bootstrapdash',
        meta: 'Bootstrapdash creates quality admin templates that are based on Bootstrap, the most popular front end development framework.',
    },
    {
        id: 7,
        title: 'Bootstrapdash.com (@bootstrapdash) | Twitter',
        link: 'https://twitter.com/@bootstrapdash',
        meta: 'The latest Tweets from bootstrapdash.com (@bootstrapdash). Clean, customisable admin dashboard template themes / UI WebApp Kits with a huge collection of pre-built widgets and plugins.',
    },
    {
        id: 8,
        title: 'Bootstrapdash on Behance',
        link: 'https://www.behance.net/bootstrapdash',
        meta: 'Awesome Bootstrap Admin Dashboard Templates. For Faster, Easier Web Applications Development. Clean, customizable admin dashboard template theme / UI WebApp Kit with a huge collection of pre-built widgets and plugins. Design and build modern, robust, user-friendly web applications real fast!',
    },
]